import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AppConstants } from '../app.constants';
import { StorageService } from '../services/storage.service';

@Injectable({
  providedIn: 'root'
})
export class VisitorGuard implements CanActivate {

  constructor(
    public router: Router,
    public storageService: StorageService) {
  }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const hasToken = !!this.storageService.getItem(AppConstants.Token);
    const hasCustomer = !!this.storageService.getItem(AppConstants.Customer);
    if (hasToken && hasCustomer) {
      this.router.navigate([AppConstants.RouteSelectConsultation]);
      return false;
    }
    else {
      this.storageService.removeItem(AppConstants.Token);
      this.storageService.removeItem(AppConstants.Customer);
      return true;
    }
  }
}
